let sharedVars = {
	
	// API
	'slryApiDom': 'k8s.',
	'apiPromise': null,
	'allYrApiData': null,
	
	// Specialty
	'homePageId': null,
	'userSpecRank': null,
	
	//Location
	'userLoc': null,
	'userCity': null,
	'userDma': null,
	'userDmaRank': null,
	'userState': null,
	'userRegion': null,	
	'citySelected': false,
	
	// Years of Experience
	'userYoe': null,
	'userYoeIdx': null,
	'userYoeRng': null,
	
	// Employment Status
	'userEmp': null,
	'userEmpIdx': '',
	'userEmpQry': '',
	
	// Ads
	'adAppended': false,
	
	// Back Button
	'apiPending': false,
	'prevURL': null,
	
	// Scroll 
	'scrollElem': null,
	'widgClasses': ['.slry-avg-like-you', '.slry-card.growth', '.slry-card.pract-setting', '.slry-card.specs', '.slry-card.indiv', '.slry-card.locs', '.slry-card.gender'],
	'pendingLoad': 0,
	'prevScrollPos': null,
	'isScrolling': false,
	
	// Widget / Query
	'widgNames': ['avgLikeYou', 'avgSalGrowth', 'topSalarySpecialty', 'avgBreakDownPractice', 'topSalaryIndividuals', 'topSalaryDmac', 'avgBreakDownGender'],
	'widgData': {
		'avgLikeYou': null,
		'avgSalGrowth': null,
		'topSalarySpecialty': null,
		'avgBreakDownPractice': null,
		'topSalaryIndividuals': null,
		'topSalaryDmac': null,
		'avgBreakDownGender': null
	},
	'widgPending': {
		'avgLikeYou': null,
		'avgSalGrowth': null,
		'topSalarySpecialty': null,
		'avgBreakDownPractice': null,
		'topSalaryIndividuals': null,
		'topSalaryDmac': null,
		'avgBreakDownGender': null
	},
	
	'labelsAppended': false,	
	'blockTyping': false
	
};

export default sharedVars;